export enum AccountOnboardingStatus {
    Intro = 'intro',
    CompanyLegal = 'company_legal',
    SubmitSiteList = 'submit_sitelist',
    DownloadAdsTxt = 'download_ads_txt',
    DemoWidget = 'demo_widget',
    Done = 'done',
}